<div class="day-of-week-edit__container">
  <div class="day-of-week-edit__container__day">
    <span>{{ dayDisplayNameKey(dayOfWeek) | translate }}</span>
    <mat-slide-toggle [checked]="!closed" (change)="toggleChanged()" [color]="'primary'"></mat-slide-toggle>
  </div>
  <div class="day-of-week-edit__container__times">
    <div *ngIf="closed">
      <span class="day-of-week-edit__time-span day-of-week-edit__time-span--closed">
        {{
          (dayOfWeek === DayOfWeek.PUBLIC_HOLIDAYS
            ? 'FRONTEND.FORMS.HOURS_OF_OPERATION.NONE'
            : 'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSED'
          ) | translate
        }}
      </span>
    </div>

    <ng-container *ngIf="!closed">
      <div>
        <div
          *ngFor="let span of value || [{}]; let i = index; let first = first; let last = last"
          class="day-of-week-edit__time-span"
        >
          <forms-hoo-time-span
            (hasAnyErrors)="handleHasAnyErrors($event, i)"
            [value]="span"
            (valueChange)="value[i] = $event"
            [allowDelete]="value.length > 1"
            (delete)="delete(i)"
            [disableTimeSelectors]="dayOfWeek === DayOfWeek.PUBLIC_HOLIDAYS"
            [isHolidayHours]="dayOfWeek === DayOfWeek.PUBLIC_HOLIDAYS"
          ></forms-hoo-time-span>
        </div>
      </div>
      <div class="day-of-week-edit__add-hours-button">
        <button mat-button [color]="'primary'" (click)="addHours()">
          {{
            (dayOfWeek === DayOfWeek.PUBLIC_HOLIDAYS
              ? 'FRONTEND.FORMS.HOURS_OF_OPERATION.ADD_NOTES'
              : 'FRONTEND.FORMS.HOURS_OF_OPERATION.ADD_HOURS'
            ) | translate
          }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
